import { render, staticRenderFns } from "./MainAssetFilter.vue?vue&type=template&id=670c10aa&scoped=true&"
import script from "./MainAssetFilter.vue?vue&type=script&lang=js&"
export * from "./MainAssetFilter.vue?vue&type=script&lang=js&"
import style0 from "./MainAssetFilter.vue?vue&type=style&index=0&id=670c10aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c10aa",
  null
  
)

export default component.exports